import { PRINTABLE_CHARS_ERROR_MESSAGE } from "@/shared/lib/printable-chars";

// Mirrors the server's name check, which refuses only < and >. Names must not use the
// printable-character check: it also refuses ’ and letters outside Latin-1, which the server accepts.
export const nameCharsRule = (v) =>
  !v || !/[<>]/.test(v) || PRINTABLE_CHARS_ERROR_MESSAGE;
